var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-button no-highlight-select"},[_c('button',{staticClass:"relative",staticStyle:{"z-index":"10"},on:{"click":_vm.onClick}},[_c('icon-back')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }